export enum HotReloadMethod {
  Enabled = '开启热重载',
  // TODO: 实现 entry 热重载
  // StylesOnly = '仅样式',
  Disabled = '关闭热重载',
}
export enum RefreshMethod {
  AlwaysRefresh = '总是刷新',
  DoNotRefresh = '不刷新',
}
